import { styled, css } from 'canoe';
import React from 'react';

import MousePlacementIcon from '!!react-svg-loader!./assets/MousePlacementIcon.svg';

const MousePlacementCard = styled.div`
  ${({ theme }) => css`
    align-items: center;
    border: 1px solid ${theme.colors.GlitterGrayD10};
    border-radius: ${theme.borderRadius.small};
    font-size: ${theme.fonts.small.fontSize};
    display: flex;
    flex-direction: row;
    color: ${theme.colors.OnyxGray}
    font-size:14px;
    padding: 10px 16px;
  `}
`;

export const MousePlacementHint = React.memo(() => (
  <MousePlacementCard>
    <MousePlacementIcon />
    Use your mouse to choose where to place content
  </MousePlacementCard>
));
